package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

@Serializable
data class UserProfile(
    val id: String = "",
    val avatar: String = "",
    val role: String = "",
    val firstName: String = "",
    val lastName: String = "",
    val email: String? = null,
    val phone: String? = null,
    val primaryAuthMethod: String, // "EMAIL" ou "PHONE"
    val isTwoFactorEnabled: Boolean = false,
    val city: String = "Douala",             // Ex: Douala, Yaoundé
    val country: String = "Cameroun",        // Ex: Cameroun
    val countryCode: String = "cm",          // Ex: cm
    val timezone: String = "Africa/Douala",
    val isLoggedIn: Boolean = true,
    val loginTimestamp: Long = 0L
)

@Serializable
data class IpLocationResponse(
    val city: String? = "Douala",
    val country_name: String? = "Cameroon",
    val country_code: String? = "cm",
    val timezone: String? = "Africa/Douala"
)
